import React from 'react';
import { describe } from '@elliemae/ds-props-helpers';
import { StyledContainer } from './styles.js';
import type { DSFormLayoutCheckboxGroupT } from './react-desc-prop-types.js';
import { propTypes } from './react-desc-prop-types.js';
import { useFormLayoutCheckboxGroup } from './config/useFormLayoutCheckboxGroup.js';

const DSFormLayoutCheckboxGroup = (props: DSFormLayoutCheckboxGroupT.Props): JSX.Element => {
  const {
    globalAttributes: { ...othersGlobalAttributes },
    xstyledProps,
    propsWithDefault,
  } = useFormLayoutCheckboxGroup(props);
  return (
    <StyledContainer
      role={propsWithDefault.isInsideLayoutBlock ? undefined : 'group'}
      direction={propsWithDefault.direction}
      {...othersGlobalAttributes}
      {...xstyledProps}
    >
      {propsWithDefault.children}
    </StyledContainer>
  );
};

DSFormLayoutCheckboxGroup.displayName = 'DSFormLayoutCheckboxGroup';
const DSFormLayoutCheckboxGroupWithSchema = describe(DSFormLayoutCheckboxGroup);
DSFormLayoutCheckboxGroupWithSchema.propTypes = propTypes;

export { DSFormLayoutCheckboxGroup, DSFormLayoutCheckboxGroupWithSchema };
